import React from 'react'

import Home from '@components/Home'
import { initSocket } from '@contexts/Socket'

const HomePage = () => {
  React.useEffect(() => {
    initSocket()
  }, [])

  return <Home />
}

export default HomePage
